module.exports = __webpack_public_path__ + "static/img_9360-8113844d44e7576b82d2435924b5f457.webp";